export default __webpack_public_path__ + "static/media/team.4597db78.jpg";